<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs>
        <v-layout row wrap justify-center align-center ma-0 pt-8 pa-0>
          <v-flex xs12 lg12>
            <v-card-text class="pa-2">
              <v-layout row wrap justify-center ma-0 pa-2>
                <v-flex xs11 sm11 md3 lg3 pa-2>
                  <v-card
                    outlined
                    class="colorPurple rounded-lg elevation-0"
                    @click="Fn_ShowDataConsent('All')"
                  >
                    <v-card-text
                      class="pa-2 text-center"
                      style="color: #0040ff"
                    >
                      <v-layout row wrap justify-center align-center>
                        <v-flex xs3 sm3 md3 lg3>
                          <img
                            width="58"
                            :src="
                              require('@/assets/img/ConsentList/checklist.png')
                            "
                        /></v-flex>
                        <v-flex xs9 sm9 md9 lg9>
                          <b> รายการความยินยอมทั้งหมด </b>
                          <div class="pt-3">
                            <b style="font-size: 38px"> {{ ItemCount.All }}</b>
                            รายการ
                          </div>
                        </v-flex></v-layout
                      >
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs11 sm11 md3 lg3 pa-2>
                  <v-card
                    outlined
                    class="colorWhiteGreen rounded-lg elevation-0"
                    @click="Fn_ShowDataConsent('Active')"
                  >
                    <v-card-text class="pa-2 text-center green--text">
                      <v-layout row wrap justify-center align-center>
                        <v-flex xs3 sm3 md3 lg3>
                          <img
                            width="60"
                            :src="
                              require('@/assets/img/ConsentList/fileCheck.png')
                            "
                        /></v-flex>
                        <v-flex xs9 sm9 md9 lg9>
                          <b> ความยินยอมที่ใช้งาน </b>
                          <div class="pt-3">
                            <b style="font-size: 38px">
                              {{ ItemCount.Active }}</b
                            >
                            รายการ
                          </div>
                        </v-flex></v-layout
                      >
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs11 sm11 md3 lg3 pa-2>
                  <v-card
                    outlined
                    class="colorCardRed rounded-lg elevation-0"
                    @click="Fn_ShowDataConsent('Expire')"
                  >
                    <v-card-text class="pa-2 text-center red--text">
                      <v-layout row wrap justify-center align-center>
                        <v-flex xs3 sm3 md3 lg3>
                          <img
                            width="60"
                            :src="
                              require('@/assets/img/ConsentList/fileClose.png')
                            "
                        /></v-flex>
                        <v-flex xs9 sm9 md9 lg9>
                          <b> ความยินยอมที่หมดอายุ </b>
                          <div class="pt-3">
                            <b style="font-size: 38px">
                              {{ ItemCount.Expire }}</b
                            >
                            รายการ
                          </div>
                        </v-flex></v-layout
                      >
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs11 sm11 md3 lg3 pa-2>
                  <v-card
                    outlined
                    class="colorCardGrey rounded-lg elevation-0"
                    @click="Fn_ShowDataConsent('Petition')"
                  >
                    <v-card-text class="pa-2 text-center gray--text">
                      <v-layout row wrap justify-center align-center>
                        <v-flex xs3 sm3 md3 lg3>
                          <img
                            width="60"
                            :src="
                              require('@/assets/img/ConsentList/fileDel.png')
                            "
                        /></v-flex>
                        <v-flex xs9 sm9 md9 lg9>
                          <b> ถอนความยินยอม </b>
                          <div class="pt-3">
                            <b style="font-size: 38px">
                              {{ ItemCount.Petition }}</b
                            >
                            รายการ
                          </div>
                        </v-flex></v-layout
                      >
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
          justify-center
          align-center
          pa-0
          pt-3
          v-for="(item, index) in ItemConsent"
          :key="index"
        >
          <v-flex xs12 lg12 pa-2>
            <v-card class="rounded-lg">
              <v-card-title class="pa-3">
                <div v-if="_PathType == 'general'">
                  {{ index + 1 }}. {{ item.ConsentHeader }}
                </div>
                <div v-else-if="_PathType == 'group'">
                  {{ index + 1 }}. {{ item.GroupName }}
                </div>
              </v-card-title>
              <hr class="new4" />
              <!-- <v-progress-linear
                x-small
                color="green lighten-3"
                value="100"
              ></v-progress-linear> -->
              <v-card-text class="pa-4">
                <div v-if="_PathType == 'general'">
                  <div class="mt-1 sizeFont">
                    <b>ชื่อนโยบาย</b> : {{ item.PolicyHeader }}
                  </div>
                  <div class="mt-1 sizeFont">
                    <b>วันที่ให้ความยินยอม</b> : {{ item.SendAt }}
                  </div>
                  <div class="mt-1 sizeFont">
                    <b>ชื่อองค์กร</b> : {{ item.BusinessNameTh }}
                  </div>
                  <div class="mt-1 sizeFont">
                    <b>ชื่อผู้ขอ</b> : {{ item.ReqNameTh }}
                  </div>
                </div>
                <div v-else-if="_PathType == 'group'">
                  <div class="mt-1 sizeFont">
                    <b>ชื่อนโยบาย</b> : {{ item.PolicyHeader }}
                  </div>
                  <div class="mt-1 sizeFont">
                    <b>วันที่ให้ความยินยอม</b> : {{ item.SendAt }}
                  </div>
                  <div class="mt-1 sizeFont">
                    <b>จำนวนความยินยอม</b> :
                    <v-chip color="green lighten-5" small class="green--text">
                      {{ item.CountConsent }}
                    </v-chip>
                    รายการ
                  </div>
                  <div class="mt-1 sizeFont">
                    <b>ชื่อองค์กร</b> : {{ item.BusinessNameTh }}
                  </div>
                  <div class="mt-1 sizeFont">
                    <b>ชื่อผู้ขอ</b> : {{ item.ReqNameTh }}
                  </div>
                </div>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-chip color="#DD2C00" dark v-if="item.Status === 'petition'">
                  สถานะ : ถอนความยินยอม
                  <v-icon right> mdi-progress-close </v-icon>
                </v-chip>
                <v-spacer></v-spacer>
                <v-btn
                  rounded
                  :dark="item.Status != 'petition'"
                  color="#077893"
                  @click="Fn_CheckCancel(item)"
                  class="mr-2"
                  :disabled="item.Status === 'petition'"
                >
                  <v-icon left>mdi-send-circle-outline</v-icon>
                  ยื่นคำร้อง</v-btn
                >
                <v-btn
                  rounded
                  text
                  color="info"
                  @click="Fn_ViewDetail(item)"
                  class="mr-2"
                >
                  ดูรายละเอียด</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <br /><br />
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
      <DialogPetitionRequest
        :show="DialogPetitionRequest"
        :_detail="detail"
        :_Tag="Tag"
        :GetTypeRequest="GetTypeRequest"
        @closeDialog="DialogPetitionRequest = false"
      />
    </v-main>
  </v-app>
</template>

<script>
import DialogPetitionRequest from '@/components/dialog/DialogPetitionRequestOneplateform.vue'
import OverlaySearch from '@/components/layouts/LoadingPage.vue'
import authorization from '@/functions/authorization.js'
import Swal2 from 'sweetalert2/dist/sweetalert2.js'
import { mapGetters } from 'vuex'

const Toast = Swal2.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
})
export default {
  components: { DialogPetitionRequest, OverlaySearch },
  data: function () {
    return {
      ItemConsent: [],
      ItemCount: [],
      number: [],
      AccessToken: '',
      detail: [],
      Tag: [],
      GroupByStatus: [],
      GetTypeRequest: [],
      DataCheckCancel: [],
      DialogDelete: false,
      loadingDownloadData: false,
      DialogPetitionRequest: false
    }
  },
  computed: {
    ...mapGetters(['Business']),
    ...mapGetters(['RoleAccount']),
    _RoleAccount: {
      get () {
        return this.RoleAccount || '-'
      }
    },
    _PathType: {
      get () {
        return this.$route.path.split('/')[2] || '-'
      }
    },
    headersGeneral () {
      return [
        { text: 'หมายเลขเอกสารความยินยอม', value: 'SendId', sortable: false },
        { text: 'ประเภท', value: 'SourceSystem', sortable: false },
        {
          text: 'หัวข้อความยินยอม',
          align: 'left',
          value: 'ConsentHeader',
          sortable: false
        },
        { text: 'หัวข้อนโยบาย', value: 'PolicyHeader', sortable: false },
        {
          text: 'องค์กร',
          value: 'BusinessNameTh',
          sortable: false,
          align: 'center'
        },
        { text: 'วันที่ส่ง', value: 'SendAt', sortable: false },
        { text: this.$i18n.t('consentlist.choice'), value: 'action' }
      ]
    },
    headersGroup () {
      return [
        { text: 'หมายเลขเอกสารความยินยอม', value: 'SendId', sortable: false },
        { text: 'ประเภท', value: 'SourceSystem', sortable: false },
        {
          text: 'หัวข้อกลุ่มความยินยอม',
          align: 'left',
          value: 'GroupName',
          sortable: false
        },
        { text: 'จำนวนความินยอม', value: 'CountConsent', sortable: false },
        {
          text: 'องค์กร',
          value: 'BusinessNameTh',
          sortable: false,
          align: 'center'
        },
        { text: 'วันที่ส่ง', value: 'SendAt', sortable: false },
        { text: this.$i18n.t('consentlist.choice'), value: 'action' }
      ]
    }
  },
  mounted () {
    this.Fn_GetToken()
  },
  methods: {
    async Fn_GetToken () {
      this.loadingDownloadData = true
      var payload = {
        ShareToken: this.$route.path.split('/')[4]
      }
      var Headers = {
        AccountId: this.$cookies.get('OneAccountId')
      }
      var dataEncode = await authorization.encodeDataNew(payload)
      var auth = await authorization.encodeDataNew(Headers)
      var headers = { Authorization: 'Bearer ' + auth }
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + 'token/login',
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false

          if (response.data.Status === 'OK') {
            this.AccessToken = response.data.Message.OneAccessToken
            this.$cookies.set(
              'ChatAccessToken',
              response.data.Message.OneAccessToken
            )
            this.$cookies.set(
              'ChatUsername',
              response.data.Message.OneUsername
            )
            this.$cookies.set(
              'ChatAccountId',
              response.data.Message.OneAccountId
            )
            this.Fn_getAllDataConsent()
          } else {
            Toast.fire({
              icon: 'error',
              title: response.data.ErrorMessage
            })
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false
          if (error.response) {
            Toast.fire({
              icon: 'error',
              title: error.response.data.ErrorMessage
            })
          } else if (error.request) {
            Toast.fire({
              icon: 'error',
              title: error.request
            })
          } else {
            Toast.fire({
              icon: 'error',
              title: error.message || error
            })
          }
        })
    },
    Fn_getAllDataConsent () {
      this.loadingDownloadData = true
      var SelectType = ''
      if (this.$route.path.split('/')[2] === 'general') {
        SelectType = 'General'
      } else if (this.$route.path.split('/')[2] === 'group') {
        SelectType = 'Group'
      }
      var payload = {
        AccountId: this.$route.path.split('/')[3],
        AccessToken: this.AccessToken,
        Type: SelectType
      }
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + 'onechat/History',
          payload
        )
        .then((response) => {
          this.loadingDownloadData = false

          if (response.data.Status === 'OK') {
            this.ItemConsent = response.data.Message.Consent
            this.ItemCount = response.data.Message.Count
          } else {
            Toast.fire({
              icon: 'error',
              title: response.data.ErrorMessage
            })
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false
          if (error.response) {
            Toast.fire({
              icon: 'error',
              title: error.response.data.ErrorMessage
            })
          } else if (error.request) {
            Toast.fire({
              icon: 'error',
              title: error.request
            })
          } else {
            Toast.fire({
              icon: 'error',
              title: error.message || error
            })
          }
        })
    },
    Fn_getDataConsentByStatus (status) {
      this.loadingDownloadData = true
      var SelectType = ''
      if (this.$route.path.split('/')[2] === 'general') {
        SelectType = 'General'
      } else if (this.$route.path.split('/')[2] === 'group') {
        SelectType = 'Group'
      }
      var payload = {
        AccountId: this.$route.path.split('/')[3],
        AccessToken: this.AccessToken,
        Type: SelectType
      }
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + 'onechat/History',
          payload
        )
        .then((response) => {
          this.loadingDownloadData = false

          if (response.data.Status === 'OK') {
            this.GroupByStatus = response.data.Message.Consent
            var CheckStatus = this.GroupByStatus.reduce((acc, item) => {
              if (!acc[item.Status]) {
                acc[item.Status] = []
              }
              acc[item.Status].push(item)
              return acc
            }, {})

            if (status === 'Active') {
              this.ItemConsent = [...CheckStatus.active, ...CheckStatus.action]
            } else if (status === 'Expire') {
              this.ItemConsent = CheckStatus.expire
            } else {
              this.ItemConsent = CheckStatus.petition
            }
            this.ItemCount = response.data.Message.Count
          } else {
            Toast.fire({
              icon: 'error',
              title: response.data.ErrorMessage
            })
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false
          if (error.response) {
            Toast.fire({
              icon: 'error',
              title: error.response.data.ErrorMessage
            })
          } else if (error.request) {
            Toast.fire({
              icon: 'error',
              title: error.request
            })
          } else {
            Toast.fire({
              icon: 'error',
              title: error.message || error
            })
          }
        })
    },
    Fn_ViewDetail (href) {
      this.$store.dispatch('SET_DATA_CONSENT_ONECHAT', href)
      this.$store.dispatch('SET_DATA_CONSENT_ONECHAT_PATH', this.$route.path)
      if (this._PathType === 'general') {
        this.$router.push('/oneplatform-general-history')
      } else if (this._PathType === 'group') {
        this.$router.push('/oneplatform-group-history')
      }
    },
    async Fn_CheckCancel (val) {
      this.loadingDownloadData = true
      var payload = {
        SendId: val.SendId,
        AccountId: this.$cookies.get('ChatAccountId')
      }
      var Headers = {
        AccountId: this.$cookies.get('ChatAccountId')
      }
      var dataEncode = await authorization.encodeDataNew(payload)
      var auth = await authorization.encodeDataNew(Headers)
      var headers = { Authorization: 'Bearer ' + auth }
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            'business/CheckCancelOneplatform',
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false
          if (response.data.Status === 'OK') {
            this.DataCheckCancel = response.data.Message
            this.Tag = response.data.Message.Tag
            var check = false
            for (var item of this.Tag) {
              // index += 1;
              item.checkbox = check
            }
            this.detail = this.DataCheckCancel
            this.Fn_GetTypeRequest()
            this.DialogPetitionRequest = true
          } else {
            Toast.fire({
              icon: 'error',
              title: response.data.Message.Status
            })
          }
        })
        .catch((error) => {
          this.loading = false
          if (error.response) {
            Toast.fire({
              icon: 'error',
              title: error.response.data.ErrorMessage
            })
          } else if (error.request) {
            Toast.fire({
              icon: 'error',
              title: error.request
            })
          } else {
            Toast.fire({
              icon: 'error',
              title: error.message || error
            })
          }
        })
    },
    async Fn_GetTypeRequest () {
      var payload = {
        AccountId: this.$cookies.get('ChatAccountId'),
        AccessToken: this.$cookies.get('ChatAccessToken')
      }
      var Headers = {
        AccountId: this.$cookies.get('ChatAccountId')
      }
      var dataEncode = await authorization.encodeDataNew(payload)
      var auth = await authorization.encodeDataNew(Headers)
      var headers = { Authorization: 'Bearer ' + auth }
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            'business/GetAllTypeRequest',
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === 'OK') {
            this.GetTypeRequest = response.data.Message
            // window.location.reload();
          } else {
            Toast.fire({
              icon: 'error',
              title: response.data.Message.Status
            })
          }
        })
        .catch((error) => {
          this.loading = false
          if (error.response) {
            Toast.fire({
              icon: 'error',
              title: error.response.data.ErrorMessage
            })
          } else if (error.request) {
            Toast.fire({
              icon: 'error',
              title: error.request
            })
          } else {
            Toast.fire({
              icon: 'error',
              title: error.message || error
            })
          }
        })
    },
    Fn_ShowDataConsent (val) {
      if (val === 'All') {
        this.Fn_getAllDataConsent()
      } else if (val === 'Active') {
        this.Fn_getDataConsentByStatus('Active')
      } else if (val === 'Expire') {
        this.Fn_getDataConsentByStatus('Expire')
      } else {
        this.Fn_getDataConsentByStatus('Petition')
      }
    }
  }
}
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

hr.new4 {
  border: 1px solid #077893;
}
.sizeFont {
  font-size: 13px;
}
.colorCardGrey {
  background: #cfd8dc;
}
.colorPurple {
  background: #d2ddff;
}
.colorCardRed {
  background: rgb(255, 224, 224);
}
.colorWhiteGreen {
  background: rgb(213, 250, 213);
}
</style>
